<template lang="pug">
	.ai-music--detail.flex-col.space-medium(:class="{ 'disabled-controls': isLoading }")
		.flex-row.space-medium.align-center.wrap
			.clickable.hoverable(@click="setTab('main')", :class="{ 'accent-color': tab === 'main' }") (I) {{$tCaption('Info')}}
			.clickable.hoverable(@click="setTab('lyrics')", :class="{ 'accent-color': tab === 'lyrics' }") (L) {{$tCaption('Lyrics')}}
		template(v-if="tab === 'main'")
			.flex-col.space.flex-1
				.font-small.upper.grey {{$tCaption('Style')}}
				.font-small.grey(v-if="lyricsGenerating") {{$tCaption('Generating...')}}
				.flex-row.space.align-center(v-else)
					DxTextArea.flex-1(:value.sync="item.Metadata.Style", stylingMode="filled", :height="80")
					StylesLibrary(@select="v => item.Metadata.Style = v", :currentStyle="item.Metadata.Style")
			.flex-col.space-medium
				KeywordsSelector(:value.sync="item.Metadata.Keywords", :keysActive="true")
				.flex-col.space.flex-1
					.font-small.upper.grey {{$tCaption('Vocals')}}
					DxSelectBox(:value.sync="item.Metadata.Vocals", :data-source="vocals", displayExpr="name", valueExpr="id", stylingMode="filled")
				.flex-row.space-large
					.flex-col.space.flex-3
						.font-small.upper.grey {{$tCaption('Rating')}}
						RatingControl(:value.sync="item.Rating", :size="25")
					.flex-col.space.flex-2.wrap(v-if="item.CreatedBy")
						.font-small.upper.grey {{$tCaption('Author')}}
						span {{item.CreatedBy.Title || item.CreatedBy.Name}}, {{$moment(item.Created).format('LLL')}}
			LinkedStations(v-if="item.Oid", ref="stations", :id="item.Oid", @stations="v => setStations(v)")
		template(v-if="tab === 'lyrics'")
			pre.pre-wrap(v-html="item.Metadata.Lyric")
		Loader(v-if="isLoading", :fullscreen="true")
</template>

<script>	
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import LinkedStations from './LinkedStations.vue';
	import DxTabPanel from 'devextreme-vue/tab-panel';
	import KeywordsSelector from './KeywordsSelector.vue';
	import Loader from 'app-core/Loader.vue';
	import { AI_MUSIC_VOCALS } from 'app-core/constants';
	import RatingControl from 'app-core/RatingControl.vue';
	import StylesLibrary from './StylesLibrary.vue';

	export default {
		translationCategory: 'aiMusic.Detail',
		name: 'ai-music-detail',
		components: {
			DxButton, DxTextBox, DxTextArea, DxTabPanel, LinkedStations, KeywordsSelector, Loader, DxNumberBox, DxSelectBox, RatingControl, StylesLibrary
		},
		props: ['item'],
		data() {
			return {
				isLoading: 0,
				vocals: AI_MUSIC_VOCALS.toLocale('name', this),
				tab: 'main'
			};
		},
		computed: {
			tabs() {
				return [
					{ id: 'main', name: this.$tCaption('Metadata') },
					{ id: 'keywords', name: this.$tCaption('Keywords') },
					...(this.item.Oid ? [{ id: 'links', name: this.$tCaption('Linked stations') }] : []),
				]
			},
			lyricsGenerating() {
				return this.item.Status === 1;
			}
		},
		watch: {
			'item': {
				handler() {
					if (this.$itemId === this.item?.Oid) {
						this.item.__saveDelayed();
					} else {
						this.$itemId = this.item?.Oid;
					}
				},
				deep: true
			}
		},
		mounted() {
			if (__DEBUG__)
				window.aiMusicSideformDetail = this;

			this.$itemId = this.item?.Oid;
		},
		destroyed() {
			delete this.$itemId;
		},
		methods: {
			setTab(tab) {
				switch(tab) {
					case 'lyrics':
						this.item.__ensureLoaded();
						break;
				}
				
				this.tab = tab;
			},
			setStations(v) {
				if (!this.item.hasOwnProperty('__stations')) {
					let stations = [];
					Object.defineProperty(this.item, '__stations', {
						get: () => stations,
						set: (value) => stations = value
					});
				}
				this.item.__stations = v;
			},
			async regenerateLyrics() {
				this.isLoading++;
				const results = (await this.$Data.postExternalApi('OpenAiGpt3/Run', {
					PromptCode: 'LYRICSREGENERATE',
					clientIp: this.$auth.userIP(),
					parameters: {
						Artist: this.item.Metadata.Artist,
						Lyrics: this.item.Metadata.Lyric,
						Style: this.item.Metadata.Style,
						Title: this.item.Metadata.Name,
						Song_Artist: this.item.Metadata.Artist,
						Song_Text: this.item.Metadata.Lyric,
						Song_Style: this.item.Metadata.Style,
						Song_Title: this.item.Metadata.Name
					}
				}).finally(() => this.isLoading--))?.Data?.Content;

				if (__DEBUG__)
					console.debug('regenerateLyrics', { results });

				this.item.Metadata.Lyric = results;
			},
			async regenerateStyle() {
				this.isLoading++;
				const results = (await this.$Data.postExternalApi('OpenAiGpt3/Run', {
					PromptCode: 'LYRICSSTYLEREGENERATE',
					clientIp: this.$auth.userIP(),
					parameters: {
						Artist: this.item.Metadata.Artist,
						Lyrics: this.item.Metadata.Lyric,
						Style: this.item.Metadata.Style,
						Title: this.item.Metadata.Name,
						Song_Artist: this.item.Metadata.Artist,
						Song_Text: this.item.Metadata.Lyric,
						Song_Style: this.item.Metadata.Style,
						Song_Title: this.item.Metadata.Name
					}
				}).finally(() => this.isLoading--))?.Data?.Content;

				if (__DEBUG__)
					console.debug('regenerateStyle', { results });

				this.item.Metadata.Style = results;
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.ai-music--detail {
		
	}
</style>
 